import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

let refreshRequest = null;
api.interceptors.response.use((response) => response, async (error) => {
  const original = error.config;
  const endpoint = original?.url || '';
  const skipRefresh = endpoint.includes('/auth/login') || endpoint.includes('/auth/register') || endpoint.includes('/auth/refresh');
  if (error.response?.status !== 401 || original?._retry || skipRefresh) return Promise.reject(error);
  original._retry = true;
  try {
    refreshRequest ||= api.post('/auth/refresh').finally(() => { refreshRequest = null; });
    await refreshRequest;
    return api(original);
  } catch {
    return Promise.reject(error);
  }
});

export default api;

// Helper for formatting EUR currency
export const fmtEUR = (n) => {
  if (n === null || n === undefined) return '—';
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n);
};
